module.exports = __webpack_public_path__ + "img/app_share.cc9f68cb.png";